import StoreButtons from "./StoreButtons";
import { ASSETS } from "../lib/constants";

export default function FinalCTA() {
    return (
        <section
            data-testid="final-cta"
            className="relative py-24 lg:py-32 bg-black overflow-hidden border-t border-white/5"
        >
            <div
                className="absolute inset-0 radial-glow pointer-events-none"
                aria-hidden
            />
            <div
                className="absolute inset-0 grid-backdrop opacity-40 pointer-events-none"
                aria-hidden
            />

            <div className="relative max-w-6xl mx-auto px-6 lg:px-10 text-center">
                <img
                    src={ASSETS.icon}
                    alt="TRT+"
                    className="w-16 h-16 mx-auto mb-6 rounded-2xl"
                />
                <h2 className="font-display font-bold clamp-h2 text-white">
                    Hormone optimization.
                    <br />
                    <span className="blue-glow">Understood.</span>
                </h2>
                <p className="mt-5 text-white/65 text-base lg:text-lg max-w-2xl mx-auto leading-relaxed">
                    Always evolving. Meaningfully better with every update.
                </p>
                <div className="mt-10 flex justify-center">
                    <StoreButtons testIdPrefix="final" />
                </div>
            </div>
        </section>
    );
}
